import style from "./index.module.css";

const LoadingSpinner = ({
  width = "25px",
  height = "25px",
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <div style={{ width, height }} className={style["lds-dual-ring"]}></div>
  );
};

export default LoadingSpinner;
